export default {
  myLocation: {
    'stopShowingCurrentLocation': 'Clicca per non mostrare più la mia posizione attuale',
    'showCurrentLocation': 'Clicca per mostrare la mia posizione attuale',
    'yourCurrentLocation': 'La mia posizione attuale',
    'continuously': 'Continuamente',
    'onlyOnce': 'Solo una volta',
    'continuouslyLocation': 'Aggiorna la mia posizione ogni 2 secondi',
    'onlyOnceLocation': 'Acquisisci la mia posizione solo una volta',
    'myPositionToolTip': 'Attiva la geolocalizzazione per mostrare la tua posizione e trovare più facilmente luoghi vicini'
  }
}
